/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Alreadycommittedcapital4Inputs */

const en_coinvestments_declinedeal_reasons_alreadycommittedcapital4 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Alreadycommittedcapital4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already committed capital elsewhere`)
};

/**
* | output |
* | --- |
* | "Already committed capital elsewhere" |
*
* @param {Coinvestments_Declinedeal_Reasons_Alreadycommittedcapital4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_alreadycommittedcapital4 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Alreadycommittedcapital4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Alreadycommittedcapital4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_alreadycommittedcapital4(inputs)
});
export { coinvestments_declinedeal_reasons_alreadycommittedcapital4 as "coInvestments_declineDeal_reasons_alreadyCommittedCapital" }